module.exports = __webpack_public_path__ + "static/img/002.9b69576.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/002.png
// module id = lLR9
// module chunks = 1